import React, { useEffect, useState } from "react";
import { loadSvgAsString } from "../../utils/loadSvgAsString";

const SvgComponent = ({ url, className = "", style={} }) => {
  const [svgContent, setSvgContent] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchSvg = async () => {
      try {
        const svgString = await loadSvgAsString(url);
        setSvgContent(svgString.svgContent);
        setError(false);
      } catch {
        setError(true);
      }
    };

    fetchSvg();
  }, [url]);

  if (error) {
    return <div className="icon">Error al cargar el SVG.</div>;
  }

  return (
    <div
      className={`icon ${className}`}
      style={style}
      dangerouslySetInnerHTML={{ __html: svgContent }}
    />
  );
};

export default SvgComponent;